module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/websocket/lib/version.js
// module id = ../../../../websocket/lib/version.js
// module chunks = 19